let lzma = require('lzma/src/lzma_worker.js').LZMA
let atob = require('atob')
let btoa = require('btoa')
let base64url = require('base64url')

export default {

    async compressAndEncode({ state }, payload) {
        let result = { ok: true, data: null }
        try {
            let compressed = lzma.compress(payload)
            result.data = btoa(String.fromCharCode.apply(null, new Uint8Array(compressed)))
        }
        catch (e) {
            console.log(e)
            result.ok = false
        }
        return result
    },

    async decodeAndDecompress({ state }, payload) {
        try {
            // 1. Decode the Base64 payload to a binary string
            const binaryString = atob(payload);

            // 2. Convert the binary string directly to a byte array (Uint8Array)
            const bytes = Uint8Array.from(binaryString, char => char.charCodeAt(0));

            // 3. Decompress the byte array
            const decompressedData = lzma.decompress(bytes);

            return { ok: true, data: decompressedData };
        } catch (e) {
            console.error("Decompression failed:", e);
            return { ok: false, data: null };
        }
    },

    async encode({ state }, payload) {
        let result = { ok: true, data: null }
        try {
            result.data = btoa(payload)
        }
        catch (e) {
            console.log(e)
            result.ok = false
        }
        return result
    },

    async decode({ state }, payload) {
        let result = { ok: true, data: null }
        try {
            result.data = atob(payload)
        }
        catch (e) {
            console.log(e)
            result.ok = false
        }
        return result
    },

    async base64urlEncode({ state }, payload) {
        let result = { ok: true, data: null }
        try {
            result.data = base64url.encode(payload)
        }
        catch (e) {
            console.log(e)
            result.ok = false
        }
        return result
    },

    async base64urlDecode({ state }, payload) {
        let result = { ok: true, data: null }
        try {
            result.data = base64url.decode(payload)
        }
        catch (e) {
            console.log(e)
            result.ok = false
        }
        return result
    }
}
